const translations = {
    en: {
        CREATE_ACCOUNT: 'Create your account',
        SUBTITLE:
            'Sign up with your TronLink wallet and start automated trading in minutes.',
        STEP_INSTALL_TITLE: 'Install the TronLink wallet',
        STEP_INSTALL_TEXT:
            'Add the TronLink extension, then refresh this page. Your wallet lets you hold RCC to cover the algorithm fee.',
        INSTALL_TRONLINK: 'Install TronLink',
        STEP_REGISTER_TITLE: 'Connect & create account',
        STEP_REGISTER_TEXT:
            'Approve the connection in TronLink and sign the request — no email or password needed.',
        SECURE_NOTE:
            'Your account is secured by your wallet. We never store passwords.',
        TERMS_AGREE: 'I have read and agree to RealColibri\'s',
        TERMS_CONDITIONS: 'Terms & Conditions',
        REGISTER_WITH_TRONLINK: 'Register with TronLink',
    },
    es: {
        CREATE_ACCOUNT: 'Crea tu cuenta',
        SUBTITLE:
            'Regístrate con tu billetera TronLink y empieza el trading automatizado en minutos.',
        STEP_INSTALL_TITLE: 'Instala la billetera TronLink',
        STEP_INSTALL_TEXT:
            'Añade la extensión TronLink y actualiza esta página. Tu billetera te permite tener RCC para pagar la comisión del algoritmo.',
        INSTALL_TRONLINK: 'Instalar TronLink',
        STEP_REGISTER_TITLE: 'Conectar y crear cuenta',
        STEP_REGISTER_TEXT:
            'Aprueba la conexión en TronLink y firma la solicitud: sin correo ni contraseña.',
        SECURE_NOTE:
            'Tu cuenta está protegida por tu billetera. Nunca guardamos contraseñas.',
        TERMS_AGREE: 'He leído y acepto los',
        TERMS_CONDITIONS: 'Términos y Condiciones',
        REGISTER_WITH_TRONLINK: 'Registrarse con TronLink',
    },
    ru: {
        CREATE_ACCOUNT: 'Создайте аккаунт',
        SUBTITLE:
            'Зарегистрируйтесь через кошелёк TronLink и запустите автоторговлю за пару минут.',
        STEP_INSTALL_TITLE: 'Установите кошелёк TronLink',
        STEP_INSTALL_TEXT:
            'Добавьте расширение TronLink и обновите страницу. Кошелёк позволит хранить RCC для оплаты комиссии за алгоритм.',
        INSTALL_TRONLINK: 'Установить TronLink',
        STEP_REGISTER_TITLE: 'Подключитесь и создайте аккаунт',
        STEP_REGISTER_TEXT:
            'Подтвердите подключение в TronLink и подпишите запрос — без почты и пароля.',
        SECURE_NOTE:
            'Аккаунт защищён вашим кошельком. Мы не храним пароли.',
        TERMS_AGREE: 'Я прочитал и согласен с',
        TERMS_CONDITIONS: 'Условиями и положениями',
        REGISTER_WITH_TRONLINK: 'Зарегистрироваться через TronLink',
    },
    hy: {
        CREATE_ACCOUNT: 'Ստեղծեք ձեր հաշիվը',
        SUBTITLE:
            'Գրանցվեք ձեր TronLink դրամապանակով և սկսեք ավտոմատ առևտուրը րոպեների ընթացքում:',
        STEP_INSTALL_TITLE: 'Տեղադրեք TronLink դրամապանակը',
        STEP_INSTALL_TEXT:
            'Ավելացրեք TronLink ընդլայնումը և թարմացրեք էջը: Դրամապանակը թույլ է տալիս պահել RCC՝ ալգորիթմի վճարը ծածկելու համար:',
        INSTALL_TRONLINK: 'Տեղադրել TronLink-ը',
        STEP_REGISTER_TITLE: 'Միացեք և ստեղծեք հաշիվ',
        STEP_REGISTER_TEXT:
            'Հաստատեք միացումը TronLink-ում և ստորագրեք հարցումը՝ առանց էլ. փոստի և գաղտնաբառի:',
        SECURE_NOTE:
            'Ձեր հաշիվը պաշտպանված է ձեր դրամապանակով: Մենք երբեք չենք պահում գաղտնաբառերը:',
        TERMS_AGREE: 'Ես կարդացել եմ և համաձայն եմ RealColibri-ի',
        TERMS_CONDITIONS: 'Պայմաններն ու դրույթները',
        REGISTER_WITH_TRONLINK: 'Գրանցվել TronLink-ով',
    },
    fr: {
        CREATE_ACCOUNT: 'Créez votre compte',
        SUBTITLE:
            'Inscrivez-vous avec votre portefeuille TronLink et lancez le trading automatisé en quelques minutes.',
        STEP_INSTALL_TITLE: 'Installez le portefeuille TronLink',
        STEP_INSTALL_TEXT:
            'Ajoutez l\'extension TronLink, puis actualisez cette page. Votre portefeuille permet de détenir des RCC pour payer la commission de l\'algorithme.',
        INSTALL_TRONLINK: 'Installer TronLink',
        STEP_REGISTER_TITLE: 'Connectez-vous et créez un compte',
        STEP_REGISTER_TEXT:
            'Approuvez la connexion dans TronLink et signez la demande — sans e-mail ni mot de passe.',
        SECURE_NOTE:
            'Votre compte est sécurisé par votre portefeuille. Nous ne stockons jamais de mots de passe.',
        TERMS_AGREE: 'J\'ai lu et j\'accepte les',
        TERMS_CONDITIONS: 'Termes et Conditions',
        REGISTER_WITH_TRONLINK: 'S\'inscrire avec TronLink',
    },
    de: {
        CREATE_ACCOUNT: 'Konto erstellen',
        SUBTITLE:
            'Registrieren Sie sich mit Ihrer TronLink-Wallet und starten Sie den automatisierten Handel in wenigen Minuten.',
        STEP_INSTALL_TITLE: 'TronLink-Wallet installieren',
        STEP_INSTALL_TEXT:
            'Fügen Sie die TronLink-Erweiterung hinzu und aktualisieren Sie die Seite. Mit Ihrer Wallet halten Sie RCC zur Begleichung der Algorithmus-Gebühr.',
        INSTALL_TRONLINK: 'TronLink installieren',
        STEP_REGISTER_TITLE: 'Verbinden & Konto erstellen',
        STEP_REGISTER_TEXT:
            'Bestätigen Sie die Verbindung in TronLink und signieren Sie die Anfrage — ohne E-Mail oder Passwort.',
        SECURE_NOTE:
            'Ihr Konto wird durch Ihre Wallet gesichert. Wir speichern niemals Passwörter.',
        TERMS_AGREE: 'Ich habe gelesen und stimme den',
        TERMS_CONDITIONS: 'Nutzungsbedingungen zu',
        REGISTER_WITH_TRONLINK: 'Mit TronLink registrieren',
    },
    it: {
        CREATE_ACCOUNT: 'Crea il tuo account',
        SUBTITLE:
            'Registrati con il tuo wallet TronLink e avvia il trading automatico in pochi minuti.',
        STEP_INSTALL_TITLE: 'Installa il wallet TronLink',
        STEP_INSTALL_TEXT:
            'Aggiungi l\'estensione TronLink e aggiorna la pagina. Il wallet ti permette di detenere RCC per pagare la commissione dell\'algoritmo.',
        INSTALL_TRONLINK: 'Installa TronLink',
        STEP_REGISTER_TITLE: 'Connetti e crea account',
        STEP_REGISTER_TEXT:
            'Approva la connessione in TronLink e firma la richiesta — senza email né password.',
        SECURE_NOTE:
            'Il tuo account è protetto dal tuo wallet. Non memorizziamo mai le password.',
        TERMS_AGREE: 'Ho letto e accetto i',
        TERMS_CONDITIONS: 'Termini e Condizioni',
        REGISTER_WITH_TRONLINK: 'Registrati con TronLink',
    },
}

export default translations
